import {connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import {IApplicationState} from "src/~store/models/ApplicationState";
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import {ISpecifyChatCloseReasonDialogProps} from './~types/SpecifyChatCloseReasonDialogProps';
import { getCloseChatCategoriesSettings, getTopicPairSubjectsByTopicName } from "../../chats-panel/~store/actions/actions";
import { closeChatCategoriesSelector, customChatTagsSettingSelector, isGettingTopicPairSubjectsSelector, topicPairSubjectsSelector } from "../../chats-panel/~store/selectors";
import { saveTags, saveChatCategory } from "../../chats/~store/actions/actions";
import { ITagModel } from "./~store/models/TagModel";
import { showInfoToastr, showSuccessToastr } from 'src/app/shared/helpers/toastr-helper/ToastrHelper';
import './SpecifyChatCloseReasonDialog.css';
import Select from 'react-select';
import { Button, Spinner } from "reactstrap";
import { useTranslation } from 'react-i18next';

type ReduxType = ReturnType<typeof mapStateToProps> & ISpecifyChatCloseReasonDialogProps;

const SpecifyChatCloseReasonDialog = (props: ReduxType) => {         

    const { t } = useTranslation();

    const customStyles = {
        control: (provided: any, state: any) => ({
          ...provided,
          border: 'solid',
          borderColor: '#26a69a !important',
          borderBottomWidth: '2px',
          borderTopWidth: '0px',
          borderRightWidth: '0px',
          borderLeftWidth: '0px',
          borderRadius: 'unset',
          minHeight: '0px',
          height: '45px',       
          boxShadow: 'unset !important'
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            position: 'relative',
            width: '100%',
            overflow: 'hidden',
        }),
        menuList: (provided: any, state: any) => ({
            ...provided,
            maxHeight: '200px'
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            color: state.isSelected ? 'white' : 'gray',
            backgroundColor: state.isSelected ? 'gray' : 'white',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            lineClamp: 2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '18px',
            maxHeight: '46px',
        }),
        valueContainer: (provided: any, state: any) => ({
            ...provided,
            minHeight: '0px',
            height: '45px'          
        }),
        input: (provided: any, state: any) => ({
            ...provided,
            minHeight: '0px',
            height: 'unset'      
        }),
    }

    const [category, setCategory] = useState<string>('');
    const [subject, setSubject] = useState<string>('');
    const [chatTagsSetting, setChatTagsSetting] = useState(new Map());
    const [closeSilently, setCloseSilently] = useState(false);

    useEffect(() => {
        if(props.nlpTopicName) {
            props.getTopicPairSubjectsByTopicName(props.nlpTopicName);
        }
        props.getCloseChatCategoriesSettings();
    }, [props.nlpTopicName]);

    useEffect(() => {
        setCategory('');
        setSubject('');
        setChatTagsSetting(new Map());
        setCloseSilently(false);
    }, [props.chatId])

    const onChangeCategory = (e: any) => {
        setCategory(e.value);
    }

    const onChangeSubject = (e: any) => {
        setSubject(e.value);
    }

    const onChangeCustomTag = (e: any, k: string) => {
        chatTagsSetting.set(k, e.value);
        setChatTagsSetting(chatTagsSetting);
    }

    const TagsAreChosen = (): boolean => {
        if ((!category && props.closeChatCategories.length > 0) || (!subject && props.topicPairSubjects.length > 0)
            || chatTagsSetting.size < _getChatTagsKeysFromSettingValue(undefined).length) {
                return false;
        }
        return true;
    }

    const GetTagModels = () : ITagModel[] => {
        const tags: ITagModel[] = [];

        if(subject){
            tags.push({
                chatId: props.chatId,
                name: "subject",
                value: subject
            } as ITagModel);
        }

        if (chatTagsSetting.size) {
            chatTagsSetting.forEach((v, k) => {
                tags.push({
                    chatId: props.chatId,
                    name: k,
                    value: v
                } as ITagModel)
            })
        }

        return tags;
    }

    const SaveTagsAndCategory = () => {

        if (!TagsAreChosen()) {
            showInfoToastr(t('chat.categoryAndSubjectSavedError'));
            return;
        }
        if (category) {
            props.saveChatCategory(props.chatId, category);
        }
        const tags = GetTagModels();
        props.saveTags(tags);
        props.setIsVisible(false);
        showSuccessToastr(t('chat.categoryAndSubjectSavedSuccessfully'));

        props.closeChat(props.chatId, true, closeSilently);
    }

    const onCloseHandler = () => {
        const hasSelectedData = !!category || !!subject || chatTagsSetting.size > 0;
        if (hasSelectedData && !window.confirm(t('chat.closeDialogWithoutSaving'))) {
            return;
        }
        props.setIsVisible(false);
    };

    const _getChatTagsFromSettingValue = () => {
        return JSON.parse(props.chatTagsSetting?.value ?? '{}');
    }

    const _getChatTagsKeysFromSettingValue = (tags: any | undefined) => {
        return Object.keys(tags ? tags : _getChatTagsFromSettingValue());
    }

    const _renderCustomChatTags = () => {
        var tags = _getChatTagsFromSettingValue();
        var keys = _getChatTagsKeysFromSettingValue(tags);
        return (
            <>
                {keys.map((key, index) => (
                    <Select
                        key={index}
                        id={key}
                        className='close-reason-container__select'
                        options={(tags[key] as string).split(',').map(s => ({ value: s, label: s }))}
                        placeholder={key}
                        onChange={e => { onChangeCustomTag(e, key) }}
                        styles={customStyles}
                        menuShouldScrollIntoView={false}
                    />
                    )
                ) }
            </>
        );
    }

    const _getHeader = () => {
        return(
            <>  
                <div className='close-reason-container__question'>{t('chat.fillInfo')}</div>
                <div className="hide-chat-panel-button close-chat-panel-button">
                    <img alt="" onClick={onCloseHandler}></img>
                </div>
            </>
        );
    }

    const _getBody = () => {

        return(
            <div className="chat-close-container" data-testid="close-reason-dialog">
                <div className="chat-close-body">
                    {props.canCloseSilently && (
                        <div className="close-reason-container__checkbox">
                            <label className="close-reason-container__checkbox-label">
                                <input type="checkbox" checked={closeSilently} onChange={(e) => setCloseSilently(e.currentTarget.checked)}/>
                                <span>{t("chat.closeSilently")}</span>
                            </label>
                        </div>
                    )}
                    {props.closeChatCategories.length > 0 && <Select
                        id="category"
                        className='close-reason-container__select'
                        options={props.closeChatCategories}
                        placeholder={t('chat.category')}
                        onChange={onChangeCategory}
                        styles={customStyles}
                        menuShouldScrollIntoView={false}
                    />}
                    {props.topicPairSubjects.length > 0 && <Select
                        id="subject"
                        className='close-reason-container__select'
                        options={props.topicPairSubjects}
                        placeholder={t('chat.subject')}
                        onChange={onChangeSubject}
                        styles={customStyles}
                        menuShouldScrollIntoView={false}
                    />}
                    {_renderCustomChatTags()}
                    {props.isgettingTopicPairSubjects && <div className="close-reason-container_spinner"><Spinner /></div>}
                </div>
            </div>
        );
    }

    const _getFooter = () => {
        return (
            <Button className='close-reason-container__button' data-testid="close-reason-submit" disabled={ props.isgettingTopicPairSubjects} onClick={() => {SaveTagsAndCategory();}}>{t('chat.closeChat')}</Button>
        );
    }    

    return (        
        <ModalWindow 
            className='chat__close-reason-container'
            isOpen={props.isVisible}
            header={_getHeader()}
            body={_getBody()}
            footer={_getFooter()}
        />
    );

}

const mapStateToProps = (state: IApplicationState, props: any) => {
    return {
        topicPairSubjects: topicPairSubjectsSelector(state),
        closeChatCategories: closeChatCategoriesSelector(state),
        chatTagsSetting: customChatTagsSettingSelector(state),
        isgettingTopicPairSubjects: isGettingTopicPairSubjectsSelector(state),
        isVisible: props.isVisible,
        nlpTopicName: props.nlpTopicName,
        setIsVisible: props.setIsVisible,
        closeChat: props.closeChat,
        chatId: props.chatId,
        canCloseSilently: props.canCloseSilently
    };
};

const mapDispatchToProps = (dispatch: any): ISpecifyChatCloseReasonDialogProps => {
    return {
        getTopicPairSubjectsByTopicName: (topicName: string) => dispatch(getTopicPairSubjectsByTopicName(topicName)),
        getCloseChatCategoriesSettings: () => dispatch(getCloseChatCategoriesSettings()),
        saveTags: (tags: ITagModel[]) => dispatch(saveTags(tags)),
        saveChatCategory: (chatId: number, chatCategory: string) => dispatch(saveChatCategory(chatId, chatCategory))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecifyChatCloseReasonDialog);